import TipoIndicador from "..";
import ADC from "entity/Indicador/ADC";
import PC from "entity/Indicador/PC";
import ADO from "entity/Indicador/ADO";
import AC from "entity/Indicador/AC";
export default class Canterizacao extends TipoIndicador {
    static get abbrev() {
        return 'Canterizacao';
    }
    static get field() {
        return 'canterizacao';
    }

    static get fullName() {
        return "Canterização";
    }

    static get indicadores() {
        return [ADC, PC, ADO, AC];
    }
}
